import styled from 'styled-components';

export const Container = styled.div<{ bgColor: string; borderColor: string; textColor: string }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  width: fit-content;
  max-width: min(40rem, calc(100vw - 2rem));
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  font-family: inherit;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Title = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
`;

export const Message = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  max-width: 100%;
  white-space: pre-line;
  overflow-wrap: break-word;
`;
